import { render, staticRenderFns } from "./ExpandedCard.vue?vue&type=template&id=d9763d1e&scoped=true&"
import script from "./ExpandedCard.vue?vue&type=script&lang=js&"
export * from "./ExpandedCard.vue?vue&type=script&lang=js&"
import style0 from "./ExpandedCard.vue?vue&type=style&index=0&id=d9763d1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9763d1e",
  null
  
)

export default component.exports